import { PromoFormProps } from '@design-system/promo-form-block';

import {
  NewsletterFormProps,
  ThankYouProps,
} from '~/components/NewsletterForm/models';
import { headingBlockMapper } from '~/mappers/headingBlock';
import { imageMapper } from '~/mappers/image';
import { pageBlockUIMapper } from '~/mappers/pageBlock';

import { Form, Newsletter, ThankYou } from './models';

const formMapper = ({
  formId,
  submitErrorMessage,
  showHeading,
  thankYouPageRedirect,
}: Form): PromoFormProps => ({
  url: process.env.GATSBY_PROMO_PLATFORM_URL || '',
  formId,
  submitErrorMessage,
  showHeading,
  thankYouPageRedirect,
});

const thankYouMapper = ({
  closeButtonAriaLabel,
  heading,
  image,
}: ThankYou): Omit<ThankYouProps, 'closeHandler'> =>
  ({
    closeButtonLabel: closeButtonAriaLabel,
    heading: headingBlockMapper(heading),
    image: imageMapper(image),
  } as Omit<ThankYouProps, 'closeHandler'>);

export const newsletterMapper = ({
  pageBlockUI,
  componentId,
  heading,
  form,
  thankYou,
  uid,
}: Newsletter): NewsletterFormProps => ({
  pageBlockUI: pageBlockUIMapper(pageBlockUI[0].ui),
  componentId,
  heading: headingBlockMapper(heading),
  form: formMapper(form),
  thankYou: thankYouMapper(thankYou),
  uid,
});
